import { FaCalendarAlt, FaCreditCard } from "react-icons/fa";
import styles from "../mainpage/MainPage.module.css";
import CalendarCards from "./CalendarCards";
import PricingCards from "./PricingCards";


const CalendarPage = () => {
    return (
        <div>
            <div className="">

                {/* CALENDAR */}
                <div className="col-12 mt-5 mb-5">

                    <section id="calendar-section" className={styles.section}>

                        <div className={styles.sectionHeading}>
                            <div className={styles.sectionIcon}>
                                <FaCalendarAlt />
                            </div>

                            <div>
                                <span className={styles.sectionEyebrow}>
                                    Schedule
                                </span>

                                <h2>Calendar of Events</h2>
                            </div>
                        </div>

                        <CalendarCards />

                    </section>

                </div>

            </div>
        </div>
    )
};

export default CalendarPage;